/*
  SolarGen · Warenkorb-Waechter fuer das Hilfsprodukt 'dc-kabel-zum-set'
  ----------------------------------------------------------------
  Kabelzeilen gehoeren immer zu einer Set-Zeile. Verbunden sind sie ueber
  die Eigenschaft _sg_kabel_cfg (Set und Kabel tragen denselben Wert).
  Soll-Menge einer Kabelzeile = _sg_kabel_pro_set x Menge der Set-Zeile.

  Der Waechter prueft nach jeder Warenkorb-Aenderung und beim Seitenaufbau:
    - Set entfernt           -> Kabelzeilen raus
    - Set-Menge geaendert    -> Kabelmenge zieht mit
    - Kabel ohne Set (Link, manuell) -> raus

  Das ist Komfort, keine Sicherheitsgrenze: Warenkorb-Permalinks umgehen
  jedes Theme-Script. Die harte Absicherung ist der Shopify-Flow auf
  Bestellebene (Tag 'kabel-ohne-set', Versand anhalten).
*/
(function () {
  if (window.__sgKabelGuard) return;
  window.__sgKabelGuard = true;

  var HANDLE = 'dc-kabel-zum-set';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var busy = false;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 250);
  }

  function refreshCartUi() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
  }

  async function check() {
    if (busy) return;
    busy = true;
    try {
      var cart = await (await nativeFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })).json();
      var items = cart.items || [];
      if (!items.some(function (i) { return i.handle === HANDLE; })) return;

      var setQtyByCfg = {};
      items.forEach(function (i) {
        var cfg = i.properties && i.properties._sg_kabel_cfg;
        if (cfg && i.handle !== HANDLE) setQtyByCfg[cfg] = (setQtyByCfg[cfg] || 0) + i.quantity;
      });

      var updates = {};
      var dirty = false;
      items.forEach(function (i) {
        if (i.handle !== HANDLE) return;
        var p = i.properties || {};
        var per = parseInt(p._sg_kabel_pro_set, 10) || 0;
        var target = p._sg_kabel_cfg && per ? per * (setQtyByCfg[p._sg_kabel_cfg] || 0) : 0;
        if (i.quantity !== target) { updates[i.key] = target; dirty = true; }
      });
      if (!dirty) return;

      await nativeFetch(ROOT + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      refreshCartUi();
    } catch (e) {
      /* Nie den Warenkorb blockieren; die Bestell-Pruefung faengt den Rest. */
    } finally {
      busy = false;
    }
  }

  /* Jede Warenkorb-Aenderung des Themes laeuft ueber fetch. Eigene Requests
     gehen ueber nativeFetch und loesen deshalb keine Schleife aus. */
  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) promise.then(schedule, schedule);
    } catch (e) {}
    return promise;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
})();
